import { api } from '@shared/config/axios';

export default {
  getCalendarEvents(params) {
    return api.$get('/calendar_events', { params });
  },
  getCalendarEvent(uuid) {
    return api.$get(`/calendar_events/${uuid}`);
  },
  createCalendarEvent(data) {
    return api.$post('/calendar_events', data);
  },
  updateCalendarEvent(uuid, data) {
    return api.$put(`/calendar_events/${uuid}`, data);
  },
  deleteCalendarEvent(uuid) {
    return api.$delete(`/calendar_events/${uuid}`);
  },
};
